/// <amd-module name="Artifacts/Maven/commands/Restore" />
import { MavenActions } from "Artifacts/Maven/redux";
import { getRestoreCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createRestoreCommand = getRestoreCommandCreator(MavenActions.restore);
